import React, { createContext, useContext } from "react";
import { useDarkMode } from "../hooks/useDarkMode";
import type { ThemeMode } from "../hooks/useDarkMode";

type DarkModeContextValue = ReturnType<typeof useDarkMode>;

const DarkModeContext = createContext<DarkModeContextValue | null>(null);

export function DarkModeProvider({ children }: { children: React.ReactNode }) {
  const value = useDarkMode();
  return (
    <DarkModeContext.Provider value={value}>{children}</DarkModeContext.Provider>
  );
}

export function useDarkModeContext(): DarkModeContextValue {
  const ctx = useContext(DarkModeContext);
  if (!ctx) throw new Error("useDarkModeContext must be used within DarkModeProvider");
  return ctx;
}

export type { ThemeMode };
